<template>
  <div>
    <v-dialog v-model="dateConfigModal" persistent scrollable full-width max-width='350'>
    <!-- <div class="link-green" slot="activator" v-else>
      <v-icon>settings</v-icon>
    </div> -->
    <v-card class="pl-5 pr-5 no-details">
      <v-card-title class="pa-0 pt-4 pb-3">
        <v-flex>
          <h6>
            Configurar datas
            <v-tooltip right>
              <v-icon class="ml-2 link" slot="activator" color="blue">help_outline</v-icon>
              <span>Informar as datas em que sua equipe realizará os serviços.</span>
            </v-tooltip>
          </h6>          
        </v-flex>
        <!-- <v-spacer></v-spacer> -->
        <v-flex class="text-xs-right">
          <v-btn class="ma-0" icon @click="dateConfigModal = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs12 class="mt-2">
          <hr>
        </v-flex>
      </v-card-title>
      <v-card class="mb-2 elevation-0">
        <c-date-picker
          mode='multiple'
          :value="selectedDate"
          @input="updateScheduleDate"
          :show-popover="false"
          popover-visibility="hidden"
          is-inline>
        </c-date-picker>
        <!-- :min-date="new Date().setDate(new Date().getDate() - 1)" -->        
      </v-card>
      <v-btn :disabled="!selectedDatesLength" color="red darken-1" dark @click="dateConfigModal = false">
        Ok
      </v-btn>  
  </v-card>
</v-dialog>

  </div>
</template>


<script>
import moment from 'moment'
export default {
  name: 'date-config',
  methods: {
    updateScheduleDate (value) {
      this.$store.commit('updateScheduleDate', value)
    }
  },
  computed: {
    selectedDate () {
      let dates = []
      for (let i = 0; i < this.$store.getters.selectedSchedule.dates.length; i++) {
        dates.push(new Date(moment(this.$store.getters.selectedSchedule.dates[i]).format('MM/DD/YYYY')))
      }
      return dates || []
    },
    dateConfigModal: {
      get () {
        return this.$store.getters.dateConfigModal
      },
      set (value) {
        this.$store.commit('toggleDateConfigModal', value)
      }
    },
    selectedDatesLength () {
      return this.$store.getters.selectedSchedule.dates.length > 0
    }
  }
}
</script>
<style>
.popover-origin.direction-bottom.align-center{
  display: none!important;
}
</style>



// WEBPACK FOOTER //
// DateConfig.vue?8bbf8628